import { useQuery } from '@tanstack/react-query'

import { getFlag } from '@/ports'

import useSessionComplete from './use-session-complete'

function useFlag({ flagName }: { flagName: string }) {
  const isLoggedIn = useSessionComplete()
  const { data, isLoading } = useQuery(
    [`useFlag`, flagName],
    () => getFlag({ flagName }, undefined),
    {
      staleTime: 0,
      cacheTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
      retryOnMount: false,
      enabled: isLoggedIn,
      select: ({ body }) => {
        return body?.[flagName]?.key_value
      },
      onError: () => {
        return
      }
    }
  )

  return { data, isLoading }
}

export default useFlag
